import PropTypes from "prop-types";
import React from "react";
import * as LAEnum from "../../data/LibraryAwareEnum";
import analytics from "../../utils/analytics";
import ThumbnailContainer from "../Thumbnail/ThumbnailContainer";
import UserStar from "../UserStar/UserStar";
import * as foldersTableUtil from "./foldersTableUtilities";
import Table from "./Table";

export default function FoldersTable(props) {
	const { data, shownFolderCount, tableOptions, matchedComponentName } = props;
	const colStyles = { style: { fontWeight: "bold" } };
	const columns = foldersTableUtil.getTableColumns(colStyles);
	const options =
		tableOptions ||
		foldersTableUtil.getTableOptions(shownFolderCount, props.history, matchedComponentName);

	return (
		<Table
			title=""
			data={reshapeDataForTable(data, matchedComponentName)}
			columns={columns}
			options={options}
		/>
	);
}

FoldersTable.propTypes = {
	data: PropTypes.arrayOf(PropTypes.object)
};

/**
 * Reshape the data so that it can be consumed by Mui-Datatable
 * IMPORTANT: The order of the columns MATTER.
 * Depending on column index, we implement our custom sort.
 * Example: creation_date and last_updated columns with index 3 and 4 will
 * have a different sort since they are datetime.
 * @param {object} data
 * @param {string} matchedComponentName The matched Smart View name, needed for Amplitude logging.
 */
export function reshapeDataForTable(data, matchedComponentName) {
	return data.map(row => {

		// Each row represents a Folder which has a Starred state. We log the user interacting with this state to 
		// Amplitude. This callback gets passed to the UserStar component.
		const onClickCallback = (newStarredState) => {
			const logEvent = {
				type: analytics.eventTypes.FOLDERS.STAR_FOLDER_CLICKED,
				properties: {
					folder: {
						id: row.Id,
						name: row.Name
					},
					smartView: matchedComponentName,
					starOrUnstarred: newStarredState ? "starred" : "unstarred"
				}
			};
			analytics.logEvent(logEvent.type, logEvent.properties);
		}

		return {
			thumbnail: renderThumbnail(row.ThumbnailId, row.Name),
			star: renderStar(row.CorrelationId, row.IsStarred, onClickCallback),
			name: row.Name,
			creator: row.CreatedBy,
			creation_date: row.CreatedOn,
			last_updated: row.UpdatedOn,
			items: row.DocCount,
			id: row.Id
		};
	});
}

/**
 * Renders thumbnail for the folder
 * @param {string} thumbnailId
 */
function renderThumbnail(thumbnailId, title) {
	return (
		<ThumbnailContainer width={75} height={75} thumbnailId={thumbnailId} title={title} />
	);
}

/**
 * Renders the Star component for the folder
 * @param {string} correlationId
 * @param {bool} isStarred
 */
function renderStar(correlationId, isStarred, onClickCallback) {
	return (
		<UserStar
			correlationId={correlationId}
			isStarred={isStarred}
			starContext={LAEnum.StarContext.Promotion}
			onClickCallback={onClickCallback}
		/>
	);
}
